import React, { useState, useEffect } from "react";
import { useAuth } from './AuthContext';

export default function RolesList() {
    const [roles, setRoles] = useState([]);
    const { secureFetch } = useAuth();
    useEffect(() => {
        const fetchRoles = async () => {
            const response = await secureFetch('api/auth/roles');
            if (response.ok) {
                const data = await response.json();
                setRoles(data);
            }
        };
        fetchRoles();
    }, [secureFetch]);

    const createRole = async () => {
        const roleName = prompt("Enter new role name:");
        if (roleName) {
            const response = await secureFetch('api/auth/roles/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: null, name: roleName })
            });
            if (response.ok) {
                setRoles([...roles, roleName]);
            } else {
                alert("Failed to create role.");
            }
        }
    };

    const editRole = async (role) => {
        const newRoleName = prompt("Enter new role name:", role.name);
        if (newRoleName) {
            const response = await secureFetch('api/auth/roles/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: role.id, name: newRoleName })
            });
            if (response.ok) {
                setRoles(roles.map(r => r.id === role.id ? { ...r, name: newRoleName } : r));
            } else {
                alert("Failed to update role.");
            }
        }
    };

    const deleteRole = async (role) => {
        if (window.confirm(`Are you sure you want to delete the role: ${role.name}?`)) {
            const response = await secureFetch(`api/auth/roles/delete/${role.id}`, {
                method: 'GET'
            });
            if (response.ok) {
                setRoles(roles.filter(r => r.id !== role.id));
            } else {
                alert("Failed to delete role.");
            }
        }
    };


    return (
        <>
            <div style={{ display: 'flex' }} >
                <h2 style={{ flexGrow: 1 }} >Roles List</h2>
                <div>
                    <a class="btn btn-primary" href="javascript:void(0)" onClick={createRole}>
                        Create Role
                    </a>
                </div>
            </div>
            <div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>
                                Role Name
                            </th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roles.map((role) => (
                            <tr key={role.id}>
                                <td>
                                    {role.name}
                                </td>
                                <td>
                                    <a href="javascript:void(0)" onClick={()=>editRole(role)}>Edit</a>
                                    <span className="ms-3">|</span>
                                    <a href="Javascript:void(0);" onClick={()=>deleteRole(role)} className="ms-3">Delete</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}